import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

export const useFetchAllStampLogs = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataStampLogs, setDataStampLogs] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllStampLogs, setLoadingFetchAllStampLogs ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-all-stamp-logs`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllStampLogs(true)
        fetchData()
            .then((resp) => {
                setDataStampLogs(resp.rows)
                setLoadingFetchAllStampLogs(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllStampLogs(false)
            })
    }, [execute])

    return { dataStampLogs, loadingFetchAllStampLogs, executeFetch }

}

export const useFetchSpecificStampLog = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificStampLog, setLoadingFetchStampLog ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idstamplogs: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-specific-stamp-log/${paramsToSearch.idstamplogs}`)
            console.log('[useFetchData][useFetchSpecificStampLog] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idstamplogs > 0 ){
            setLoadingFetchStampLog(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idstamplogs: rows[0].idstamplogs || '',
                        idstamp: rows[0].idstamp || '',
                        date_transaction: rows[0].date_transaction || '',
                        type_transaction: rows[0].type_transaction || '',
                        quantity: rows[0].quantity || '',
                        observations: rows[0].observations || ''
                    }))
                    setLoadingFetchStampLog(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchStampLog(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificStampLog, setParamsToSearch, executeFetch }

}

export const useFetchStamps = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataStamps, setDataStamps] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchStamps, setLoadingFetchStamps ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-stamps`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchStamps(true)
        fetchData()
            .then((resp) => {
                setDataStamps(resp.rows)
                setLoadingFetchStamps(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchStamps(false)
            })
    }, [execute])

    return { dataStamps, loadingFetchStamps, executeFetch }

}